"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var compiler_1 = require("./tests/compiler");
exports.TestCompiler = compiler_1.TestCompiler;
var display_1 = require("./core/display");
exports.Display = display_1.Display;
var color_1 = require("./helpers/color");
exports.Color = color_1.Color;
var filesystem_1 = require("./helpers/filesystem");
exports.NetworkFilesystem = filesystem_1.NetworkFilesystem;
var clock_1 = require("./utils/clock");
exports.Clock = clock_1.Clock;
var timer_1 = require("./utils/timer");
exports.Timer = timer_1.Timer;
var profiler_1 = require("./utils/profiler");
exports.Profiler = profiler_1.Profiler;
exports.AVERAGE_CALCULATION = profiler_1.AVERAGE_CALCULATION;
exports.SUM_CALCULATION = profiler_1.SUM_CALCULATION;
var input_1 = require("./core/input");
exports.GAMEPAD_FLAG = input_1.GAMEPAD_FLAG;
exports.InputManager = input_1.InputManager;
exports.KeyboardAndMouseInput = input_1.KeyboardAndMouseInput;
exports.HaGame = {};
